import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="full-page-wrapper" style={{ 
      background: 'linear-gradient(to left bottom, #777777, #1a1a1a)', 
      minHeight: '100vh', 
      height: '100vh',
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'flex-start', 
      alignItems: 'center', 
      paddingTop: '0px',
      width: '100%'
    }}>
      <div className="app-theme" style={{ 
        padding: 'var(--spacing-lg, 30px)', 
        width: '100%', 
        maxWidth: '800px',
        position: 'relative',
        top: 0,
        left: 0
      }}>
        <div className="about-us" style={{
          position: 'relative',
          top: 0,
          left: 0
        }}>
          <h1>About Bagpipe Blasphemy</h1>
          
          <section className="about-us__section">
            <h2>Our Mission</h2>
            <p>
              Bagpipe Blasphemy is an innovative platform designed to make learning the Highland Bagpipes 
              more accessible, engaging, and fun. We combine traditional piping instruction with modern 
              technology to create an interactive learning experience.
            </p>
          </section>

          <section className="about-us__section">
            <h2>Development Status</h2>
            <p>
              This platform is actively under development, and we're constantly adding new features 
              and improvements. As we grow, we're committed to creating the best possible learning 
              experience for pipers of all skill levels.
            </p>
          </section>

          <section className="about-us__section">
            <h2>Your Feedback Matters</h2>
            <p>
              We welcome all feedback and suggestions! Your input helps shape the future of Bagpipe 
              Blasphemy. Whether you've found a bug, have a feature request, or just want to share 
              your thoughts, we want to hear from you.
            </p>
            <p>
              Please use our Contact form to get in touch with us. We review all feedback and take 
              your suggestions seriously as we continue to develop and improve the platform.
            </p>
          </section>

          <section className="about-us__section">
            <h2>Get Involved</h2>
            <p>
              Join our growing community of pipers! You can:
            </p>
            <ul className="about-us__list">
              <li>Try out our interactive learning tools</li>
              <li>Provide feedback through the Contact form</li>
              <li>Request new features you'd like to see</li>
              <li>Share your experience with other pipers!</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutUs; 